import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { STRINGS } from "./i18n";

const LANG_KEY = "kerala_cm_lang";
const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = localStorage.getItem(LANG_KEY);
    return saved === "ml" ? "ml" : "en";
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    try { localStorage.setItem(LANG_KEY, next); } catch (e) { /* ignore */ }
  }, []);

  // Reflect lang on <html> for accessibility + CSS hooks
  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang === "ml" ? "ml" : "en";
      document.documentElement.setAttribute("data-lang", lang);
    }
  }, [lang]);

  const t = useCallback(
    (key) => {
      const dict = STRINGS[lang] || STRINGS.en;
      const val = dict[key];
      return val !== undefined ? val : key;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
